import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

/**
 * Marks a string as trusted HTML without inspecting it.
 *
 * @deprecated Unsafe for anything a user or admin can author. Use the `richText` pipe from
 * `@gs-2.0/shared`, which sanitizes against an explicit allow list first.
 */
@Pipe({
  name: 'safeHTML',
})
export class SafeHTMLPipe implements PipeTransform {
  constructor(private sanitized: DomSanitizer) {}

  transform(value) {
    return this.sanitized.bypassSecurityTrustHtml(value);
  }
}
